export const STREAMLAIN_DOC_KIND_CUSTOM_PROPERTY_ID =
  'streamlain.docKind' as const;

export const STREAMLAIN_APP_BASE_ROOT_DOC_KIND = 'app-base-root' as const;

export function isStreamLainAppBaseRootDocKind(value: unknown): boolean {
  return value === STREAMLAIN_APP_BASE_ROOT_DOC_KIND;
}
